import {
    AGE_SET_VALUE,
    INCOME_FREQUENCY_SET_VALUE,
    INCOME_VALUE_SET_VALUE,
    REFERENCE_DATA_SET_VALUE,
    RESULTS_SET_VALUE,
    RESULTS_VIEW_VALUE
} from "../../../actions/incomeTaxCalculator/basicCalculator";
import {
    getTaxResult,
    getAgeValue,
    getIncomeFrequencyValue,
    getIncomeValue,
    getBasicCalculatorReferenceData
} from "../../../selectors/incomeTaxCalculator/basicCalculator";
import { simpleFieldTracking } from "../formTracking";
import { fireGtmEvent } from "../gtmEvents";
import { submitEarnEvent, earnEventMap } from '../rewards';
import { onFieldChangeStateComparison } from "../onFieldChangeStateComparison";
import { findOtherEventIndex, otherEventTracking } from "../otherEventTracking";

export const basicCalculatorFieldTracking = (store, next, action) => {
    const prevState = store.getState();
    const result = next(action);
    const currentState = store.getState();
    const onFieldChange = onFieldChangeStateComparison(prevState, currentState);

    const fieldSelector = (() => {
        switch (action.type) {
            case AGE_SET_VALUE: return getAgeValue;
            case INCOME_FREQUENCY_SET_VALUE: return getIncomeFrequencyValue;
            case INCOME_VALUE_SET_VALUE: return getIncomeValue;
            case REFERENCE_DATA_SET_VALUE: return getBasicCalculatorReferenceData;
            case RESULTS_SET_VALUE: return getTaxResult;
            default: return null;
        }
    })();

    const field = onFieldChange(fieldSelector);

    if (field) {
        const sendValue = false;
        simpleFieldTracking({ action, field, sendValue });
    }

    return result;
};

export const basicCalculatorOtherEventTracking = (store, next, action) => {
    const result = next(action);
    let otherEventIndex;
    const field = (() => {
        switch (action.type) {
            case RESULTS_VIEW_VALUE:
                otherEventIndex = findOtherEventIndex('BUTTON_CLICKED');
                submitEarnEvent(earnEventMap.incomeTax)
                    .catch(error => console.warn("submitEarnEvent failed:", error?.response?.data || error.message));

                fireGtmEvent('calculator_complete', { calculator_type: 'Income tax calculator - Basic' });
                return 'Income tax calculator - Basic';
        }
    })();

    if (field) {
        otherEventTracking(action.type, otherEventIndex, field);
    }

    return result;
}
